import React from 'react';
import { Building, Landmark, CreditCard, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const fundingOptions = [
  {
    icon: Building,
    title: 'Local Authority Funded Placements',
    description: 'Funding may be available through your local council following a care needs assessment.',
  },
  {
    icon: Landmark,
    title: 'NHS Continuing Healthcare',
    description: 'Fully funded care for those with significant ongoing healthcare needs assessed by the NHS.',
  },
  {
    icon: CreditCard,
    title: 'Self-Funded Care',
    description: 'Private funding options with flexible payment arrangements to suit your circumstances.',
  },
];

const FeesSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="fees"
      className="py-20 md:py-32 bg-white"
      data-testid="fees-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#1e3a5f]/10 rounded-full text-[#1e3a5f] text-sm font-medium mb-6">
              Fees & Funding
            </div>
            
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a5f] mb-6 leading-tight"
             
            >
              Flexible Funding Options
            </h2>

            <p className="text-slate-600 text-lg mb-8 leading-relaxed">
              We offer clear guidance on funding options. Fees vary depending on individual care needs. Our team is happy to provide personalised guidance and support.
            </p>

            <Button
              onClick={scrollToContact}
              className="bg-[#1e3a5f] text-white hover:bg-[#162c4a] rounded-full px-8 py-3 font-medium"
              data-testid="discuss-fees-btn"
            >
              <HelpCircle className="w-5 h-5 mr-2" />
              Discuss Your Options
            </Button>
          </div>

          {/* Funding Options Cards */}
          <div className="space-y-6">
            {fundingOptions.map((option, index) => {
              const IconComponent = option.icon;
              return (
                <div
                  key={option.title}
                  className="bg-slate-50 rounded-2xl p-6 hover:bg-white hover:shadow-lg transition-all duration-300 border border-transparent hover:border-[#c9a227]/30"
                  data-testid={`funding-option-${index}`}
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl bg-[#1e3a5f]/10 flex items-center justify-center flex-shrink-0">
                      <IconComponent className="w-6 h-6 text-[#1e3a5f]" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-[#1e3a5f] mb-2">{option.title}</h3>
                      <p className="text-slate-600 text-sm leading-relaxed">{option.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeesSection;
